module.exports = __webpack_public_path__ + "static/media/img006.deb53b76.jpg";